import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import serverList from "../../../components/serverList/serverOptions.vue";
import infoList from "@/mixins/infoList";
import { payCount, payCountGoods } from "@/api/data";
import { getPayMap } from "@/utils/dictionary";
export default {
  components: {
    serverList: serverList
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: payCount,
      searchInfo: {
        server_id: []
      },
      rangeList: [],
      dialog: false,
      goodsData: [],
      goodsList: {}
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPayMap();
            case 2:
              _this.goodsList = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onCustom: function onCustom() {
      var summaryRow = document.querySelector('.el-table_1_column_4 .is-center .is-leaf .el-table__cell');
      if (summaryRow) {
        summaryRow.addEventListener('click', this.onSummaryClick);
      }
    },
    onSummaryClick: function onSummaryClick() {
      // 处理 summary 行点击事件的逻辑
      console.log('Summary row clicked!');
    },
    checkPage: function checkPage() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var key;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.rangeList = [];
              _context2.next = 3;
              return _this2.getTableData();
            case 3:
              for (key in _this2.tableDataCount) {
                _this2.rangeList.push(key);
              }
              if (!_this2.tableData || _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
              //重排table,不然合计还没出来
              _this2.$refs["table"].doLayout();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getSummaries: function getSummaries(param) {
      var _this3 = this;
      var h = this.$createElement;
      var columns = param.columns;
      var sums = [];
      columns.forEach(function (column, index) {
        //设置第一列的合计值
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "充值区间";
          return;
        }
        if (index === 2) {
          sums[index] = function () {
            var el = h("div", [h("div", {
              "class": "payClass"
            }, [_this3.tableDataCount.pay_role]), h("div", {
              "class": "payRoleClass"
            }, ["(", _this3.tableDataCount.pay_role_prop, "%)"])]);
            return el;
          }();
          return;
        }
        sums[index] = function () {
          var el = h("div", [h("div", {
            "class": "countClass"
          }, [_this3.tableDataCount.pay_count]), h("div", {
            "class": "countPropClass"
          }, ["(", _this3.tableDataCount.pay_count_prop, "%)"])]);
          return el;
        }();
        return;
      });
      return sums;
    },
    openPop: function openPop() {
      this.$notify({
        title: "充值区间统计",
        message: "(1)根据历史总充值分区间统计，按角色维度统计。" + "(2)可选择服务器，打开打开默认选中全部服务器，但不查询，需要手动点查询后再展示数据，根据充值区间正序排列。" + "(3)充值区间区分为[1,10]，(10,50]，(51,100]，(100,200]，(200,500]，(500,1000]，(1000,2000]，(2000,5000]，(5000,10000]，(10000,100000]，(100000,+∞]。" + " (4)数据列包括充值区间、人数、占比、总充值金额、占比。",
        duration: 0
      });
    },
    showDialog: function showDialog(config_id) {
      var _this4 = this;
      var reqData = this.searchInfo;
      reqData.config_id = config_id;
      this.goodsData = [];
      payCountGoods(reqData).then(function (res) {
        if (res.code == 0) {
          _this4.goodsData = res.data.list;
        }
      });
      this.dialog = true;
    }
  }
};